import packageJson from '../../../../package.json';

export enum EEnvironmentName {
  production = 'PRODUCTION',
  test = 'TEST',
  branch = 'BRANCH',
  local = 'LOCAL',
}

export interface IEnvironment {
  // Off hides the ChatGPT tab/row/teaser mention until the connector is verified with real ChatGPT.
  aiConnectorChatGptEnabled: boolean;
  apiUrl: string;
  campaignCreationByPromptEnabled: boolean;
  clarity?: IClarityConfig;
  environmentName?: EEnvironmentName;
  eventTrackingConsoleLogsEnabled: boolean;
  eventTrackingEnabled: boolean;
  firebaseConfig: IFirebaseConfig;
  hubspot?: IHubspotConfig;
  mcpServerUrl: string;
  // e2e build config only (see environment.e2e.ts) - lets AdminEventAnalyticsStore serve
  // deterministic mock KPI data (AdminEventAnalyticsService) instead of the real,
  // HTTP-backed ApplicationPerformanceService, which has nothing to return against the
  // e2e/smoke stack's empty ephemeral database. Undefined/false everywhere else keeps
  // real-backend behavior unchanged.
  mockUsageAdoptionData?: boolean;
  production: boolean;
  sentry?: ISentryConfig;
  useVersionFileAppUpdateFallback: boolean;
  version: string;
}

export interface IClarityConfig {
  projectId: string;
  enabled?: boolean;
}

export interface IHubspotConfig {
  portalId: string;
  enabled?: boolean;
}

export interface ISentryConfig {
  dsn: string;
  profilesSampleRate?: number;
  replaysOnErrorSampleRate?: number;
  replaysSessionSampleRate?: number;
  sendDefaultPii?: boolean;
  tracesSampleRate?: number;
}

export interface IFirebaseConfig {
  apiKey: string;
  appId: string;
  authDomain: string;
  messagingSenderId: string;
  projectId: string;
  storageBucket: string;
}

export const defaultEnvironmentConfigs: IEnvironment = {
  aiConnectorChatGptEnabled: true,
  apiUrl: '',
  campaignCreationByPromptEnabled: true,
  environmentName: EEnvironmentName.production,
  eventTrackingConsoleLogsEnabled: false,
  eventTrackingEnabled: false,
  firebaseConfig: {
    apiKey: 'AIzaSyDu6gIkKynO-OigkYIJEjXWMrqZKG8VMGM',
    appId: '1:59820723976:web:e20d83529b925dd51466bd',
    authDomain: 'campaignmanagementtest.firebaseapp.com',
    messagingSenderId: '59820723976',
    projectId: 'campaignmanagementtest',
    storageBucket: 'campaignmanagementtest.firebasestorage.app',
  },
  mcpServerUrl: 'https://mcp.campaign-api.shikenso.org/mcp',
  production: true,
  // Every deploy should count as an update, not just semver bumps (AppUpdateService compares
  // buildTime too) - this is the single kill switch for that, early-boot and periodic alike.
  useVersionFileAppUpdateFallback: true,
  version: packageJson.version,
};
